import { useEffect, useState } from "react";
import { SOCIAL_LINKS, WhatsAppIcon } from "./social";

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show after the user scrolls past the hero
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={SOCIAL_LINKS.whatsapp}
      target="_blank"
      rel="noreferrer"
      aria-label="Scrie-ne pe WhatsApp"
      data-testid="floating-whatsapp"
      className={`fixed z-40 bottom-20 right-5 md:bottom-24 md:right-8 group transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      {/* subtle pulse ring */}
      <span className="absolute inset-0 rounded-full bg-forest/30 animate-ping opacity-60" />

      <span className="relative flex items-center gap-3 bg-forest text-bone pl-4 pr-5 py-3.5 shadow-[0_8px_24px_-8px_rgba(20,40,30,0.4)] hover:bg-forest-deep transition-colors duration-300">
        <WhatsAppIcon className="w-5 h-5 stroke-[1.5]" />
        <span className="hidden sm:inline text-[11px] uppercase tracking-wider-3">WhatsApp</span>
      </span>
    </a>
  );
}
